import React from "react"
import Imgix from "react-imgix"
import PropTypes from "prop-types"
import { OutboundLink } from "gatsby-plugin-google-analytics"

import person from "../images/install/person.svg"
import wrench from "../images/install/wrench.svg"

const InstallBlock = () => {
  return (
    <div className="install-block">
      <div className="info">
        <div className="info__wrapper">
          <div className="info__header t11 popular-header">
          Professional Installation or Easy Self-Setup
          </div>
          <div className="info__desc t5 t5--loose">
          You've customized your perfect system: now what? We offer professional installation for all of our products, and certain products also come with an option for easy self-setup. Have a question about installation? See our support page for more info - we'll be happy to help.
          </div>
          <ul className="info__list t2">
            <li>
              <img src={person} alt="" />
              Professional Installation
            </li>
            <li>
              <img src={wrench} alt="" />
              Easy Self-Setup
            </li>
          </ul>
        </div>
      </div>
      <div className="photo">
        <Imgix
          src="/popular/popular-install-full.jpg"
          width={600}
        />
      </div>
    </div>
  )
}

InstallBlock.propTypes = {}
InstallBlock.defaultProps = {}

export default InstallBlock
